"use strict";

var renderTemplate = require('./renderTemplate');

function reloadOptions($select) {
	if (!$select) return;

	var apiUrl = $select.data('apiUrl'),
		requestParams = {},
		$prev = $select.prevAll('select').first();

	while ($prev.length) {
		$.each($prev.find('option:selected').data(), function (name, value) {
			requestParams[name] = value;
		});
		$prev = $prev.prevAll('select').first();
	}

	$select.find('option:first-of-type').nextAll('option').remove();

	$.ajax(apiUrl, {
		"data" : requestParams,
		"dataType" : "json",
		"success" : function (data) {
			if (data.status == 'success' || data.status == 'maintenance') {
				$.each(data.result, function(i, item) {
					var $option = $("<option>" + item.title + "</option>");

					$.each(item.params, function (name, value) {
						$option.data(name, value);
					});
					$select.append($option);
				});
				$select.prop('disabled', false);
			} else {
				$select.parent().parent().before($('<div class="alert alert-danger">Сервис временно недоступен.</div>'));
			}
		},
		"error" : function () {
			$select.parent().parent().before($('<div class="alert alert-danger">Сервис временно недоступен.</div>'));
		}
	});
}

module.exports = function () {
	$('[js-report]').each(function () {
		var $form = $(this);

		reloadOptions($form.find('select:first-of-type'));

		$form.on('change', 'select', function () {
			var $select = $(this);

			if ($select.find('option:selected').index() > 0) {
				reloadOptions($select.nextAll('select').first());
			}

			$select.nextAll('select').each(function () {
				$(this).find('option:first-of-type').nextAll().remove();
				$(this).prop('disabled', true);
			});

			if ($select.is('[js-report] select:last-of-type') && $select.find('option:selected').index() > 0) {
				$form.find('button[type="submit"]').prop('disabled', false);
			} else {
				$form.find('button[type="submit"]').prop('disabled', true);
			}
		});

		$form.on('submit', function (event) {
			event.preventDefault();

			var $this = $(this),
				apiUrl = $this.data('apiUrl'),
				templateName = $this.data('templateName'),
				requestParams = {},
				$templateContainer = $('[handlebars-template-container]');

			$this.find('select').each(function () {
				$.each($(this).find('option:selected').data(), function (name, value) {
					requestParams[name] = value;
				});
			});

			$this.find('input[type=checkbox]:checked').each(function () {
				requestParams[this.getAttribute('name')] = true;
			});

			$.ajax(apiUrl, {
				"data" : requestParams,
				"dataType " : "json",
				"success" : function (data) {
					window.history.pushState({
						"apiUrl" : apiUrl,
						"templateName" : templateName,
						"requestParams" : requestParams
					}, null, ($form.attr('action') + '?' + decodeURIComponent($.param(requestParams))).replace(/\?$/, ''));

					renderTemplate($templateContainer, data, templateName);
					$templateContainer.data('apiUrl', apiUrl);
					$templateContainer.data('templateName', templateName);
				},
				"error": function (data) {
					renderTemplate($templateContainer, data.responseJSON);
				}
			});
		});
	});
};